module.exports = "pegasus_template/assets/blocks/header-7-tech.png";